module.exports = __webpack_public_path__ + "img/logo-transparent.c0ac28d9.png";